import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_micro_app = _resolveComponent("micro-app")

  return (_openBlock(), _createBlock(_component_micro_app, {
    name: "updates",
    "disable-scopecss": ""
  }))
}